<script>
import { selectData } from "../libraries/selectData";

import CorePlans from "../plans/CorePlans.svelte";

import BasicForm from "./steps/BasicForm.svelte";
import PaymentAnyElement from "./steps/PaymentAnyElement.svelte";
import PaymentFunnels from "./steps/PaymentFunnels.svelte";
import SignInForm from "./steps/SignInForm.svelte";
import { ItemCart, StoreCart } from "./steps/StoreCart";
import { StoreForm } from "./steps/StoreForm";

if(typeof window?.tripod_register?.lang?.forms?.agree_payment === "undefined"){
    window.tripod_register.lang.forms.agree_payment = `Al dar clic en comenzar, aceptas nuestros <a target="_blank" href="https://mi3pod.com/terminosycondiciones" class="fw600 has-text-dark is-underlined">términos de servicio</a> y <a target="_blank" href="https://mi3pod.com/terminosycondiciones" class="fw600 has-text-dark is-underlined">política de privacidad</a>`
}

let Data = window.tripod_register;

// set 3pod stripe tokens

Data.logo = Data.logo ?? "https://app.3pod.io/default/public/assets/logo/logo.svg";

// Persist referral_code from URL param or cookie
(function(){
    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = urlParams.get("referral_code");

    if(fromUrl) {
        document.cookie = `referral_code=${encodeURIComponent(fromUrl)}; path=/; max-age=2592000; SameSite=Lax`;
        Data.referral_code = fromUrl;
    } else {
        const match = document.cookie.match(/referral_code=([^;]+)/);
        if(match) Data.referral_code = decodeURIComponent(match[1]);
    }
})();

function getRegisterData(){
    return tripod_register;
}



let register_data = getRegisterData();

/**
 * Steps
*/
let step = "BasicForm"; // step1: BasicForm

let registerData = {};

function changeStep(data){
    step = data;
    return step;
}

let error = false;
let warning = false;

const errors = {
    showError: (message)=>{
        error =  message;
    },
    showWarning: (message)=>{
        warning =  message;
    },
    hide: ()=>{
        error = false;
        warning = false;
    }
}

let showModuleRegister = true;

let selectedPlan = {};
function onSelectPlan({plan, interval, button}){

    let addons = plan.addons ?? [];
    let addons_ordered = {};
    let discountPercent = plan?.discountPercent ?? 0;

    function parse(n){
        return Number.parseFloat(Number.parseFloat(n).toFixed(2));
    }
    StoreCart.restore();

    new ItemCart({
        type: "plan",
        plan: plan,
        membership_type: plan.membership_type,
        interval: interval,
        discountPercent: discountPercent,
        icon: plan.img_plan,
        name: plan.name_plan,
        prices: {
            month: {
                current: parse(plan.price_plan),
            },
            year: {
                current: parse(parse(plan?.interval_year_price ?? parse(plan.price_plan))*12),
            }
        },
    }).add();


    Object.values(addons).map(( addon, key )=>{
        if(addon.price <= 0){ return; }
        let type =  Object.keys(addons)[key];
        let addon_plan = selectData(window.getAddons3Pod(), "__id__", addon.addonPlan) ?? null;
        addon.type = type;
        addon.plan = addon_plan;

        new ItemCart({
            type: "addon",
            plan: addon.plan,
            interval: interval,
            discountPercent: discountPercent,
            icon: addon.plan.img_plan,
            name: addon.plan.name_plan,
            prices: {
                month: {
                    current: parse(addon.price),
                },
                year: {
                    current: parse(addon.price*12),
                }
            },
        }).add();

        addons_ordered[type] = addon;
    })
    if(Object.values(addons_ordered).length > 0){
        plan.addons_ordered = addons_ordered;
        plan.addons = addons_ordered;

    }


    StoreForm.update("plansFetched", [plan]);
    selectedPlan = {
        plan: plan,
        interval: interval,
        button: button,
    }

    if(typeof gtag !== "undefined"){
        try {
            gtag('event', 'btn_sign_up_widget_plan', {'send_to': "G-XEF7QBK3Z5", 'selected_plan': selectedPlan?.plan?.name_plan})
        } catch (error) {
            console.error(error)
        }
    }
    changeStep("PaymentAnyElement");
}
let box = null;
$: {
    if(step){
        if(step === "ChoosePlan"){
            showModuleRegister = false;
            if(box !== null){
                box.style.width = "100%";
                box.style.maxWidth = "1360px";
                box.style.minWidth = "320px";
            }

        }else if(step === "PaymentAnyElement"){
            showModuleRegister = true;
            if(box !== null){
                box.style.width = "100%";
                box.style.maxWidth = "1360px";
                box.style.minWidth = "320px";
            }
        }else{
            showModuleRegister = true;
            if(box !== null){
                box.style.width = "100%";
                box.style.maxWidth = "600px";
                box.style.minWidth = "320px";
            }
        }
    }
}

</script>
{#if showModuleRegister === true}
    <section class="columns is-multiline is-centered CoreRegister">
        <div class="column is-12">
            <div class="box has-text-centered container-form padding-40" bind:this="{box}">
                <container-logo role="figure">
                    <img src="{Data.logo}" alt="logo 3pod" style="max-height: 34px;margin-bottom:10px;">
                </container-logo>
                <br>
                {#if step === "SignInForm"}
                    <SignInForm Data={Data} errors={errors} changeStep={changeStep} />
                {/if}
                {#if step === "BasicForm"}
                    <BasicForm Data={Data} errors={errors} changeStep={changeStep} />
                {/if}
                {#if step === "PaymentFunnels"}
                    <PaymentFunnels Data={Data} errors={errors} changeStep={changeStep} />
                {/if}
                {#if step === "PaymentAnyElement"}
                    <PaymentAnyElement selectedPlan={selectedPlan} Data={Data} errors={errors} changeStep={changeStep} />
                {/if}
                {#if error !== false && typeof error === "string"}
                    <div class="errors">
                        <p class="has-text-danger has-text-centered">
                            {error}
                        </p>
                    </div>
                {/if}
                {#if warning !== false && typeof warning === "string"}
                    <div class="warnings">
                        <p class="has-text-warning fw600 has-text-centered">
                            {warning}
                        </p>
                    </div>
                {/if}
            </div>
        </div>
    </section>
{/if}
{#if step === "ChoosePlan"}
    <!-- on module_plans active. -->
    <CorePlans Data={Data} onSelectPlan={onSelectPlan} errors={errors} changeStep={changeStep} />
{/if}
<style>
.CoreRegister :global(*:not(i):not(.icon):not[class*='plan-icons']){
    font-family: 'Montserrat', sans-serif !important;
}
.CoreRegister :global(.under--navigation-back){
    margin-bottom: 0.25rem;
}
.container-form{
    border: 1px solid var(--color-extralightGrey);
}
.CoreRegister :global(.field-payment-agreement *),
.CoreRegister :global(.field-payment-agreement){
    font-size: 14px !important;
    font-weight: 400;
}
.CoreRegister :global(.field-payment-agreement *),
.CoreRegister :global(.payment-methods-selection){
    width: 100%;
}
</style>
